// https://icon-sets.iconify.design/uil/toilet-paper/
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesPlaygroundComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        version="1.1"
        viewBox="0 0 512.001 512.001"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M467,421.997h-37.932c-6.008,0-11.42-3.568-13.787-9.091l-33.115-77.269c-16.567-38.658-54.449-63.638-96.508-63.638
			h-15.654V152.002h15c13.666,0,20.237-16.929,10.058-26.128L160.065,3.877c-5.711-5.161-14.403-5.161-20.114,0L4.954,125.874
			c-10.181,9.2-3.608,26.128,10.057,26.128h15c0,3.296,0,326.701,0,329.992h-15c-8.284,0-15,6.716-15,15s6.716,15,15,15h29.999
			c8.284,0,15-6.716,15-15v-74.998h29.999v74.998c0,8.284,6.716,15,15,15s15-6.716,15-15v-15h59.999v15c0,8.284,6.716,15,15,15
			s15-6.716,15-15v-74.998h29.999v74.998c0,8.284,6.716,15,15,15h29.999c8.284,0,15-6.716,15-15s-6.716-15-15-15h-15
			c0-5.806,0-115.088,0-119.997h20.933c6.008,0,11.42,3.568,13.787,9.091l40.907,95.452c11.835,27.612,38.893,45.455,68.934,45.455
			h52.436c24.812,0,44.999-20.187,44.999-44.999C511.999,442.125,491.872,421.996,467,421.997z M90.008,391.997H60.009v-29.999
			h29.999V391.997z M180.006,451.996h-59.999v-29.999h59.999V451.996z M180.006,391.997h-59.999v-29.999h59.999V391.997z
			 M240.005,391.997h-29.999v-29.999h29.999V391.997z M240.005,331.999H60.009V152.003h179.996V331.999z M53.979,122.003
			l96.028-86.78l96.028,86.78H53.979z M467,481.995h-52.436c-18.025,0-34.26-10.706-41.36-27.272l-40.907-95.452
			c-7.102-16.568-23.336-27.272-41.361-27.272h-20.932V302h15.654c30.042,0,57.101,17.843,68.934,45.455l33.115,77.269
			c7.101,16.569,23.336,27.273,41.361,27.272H467c8.29,0,15,6.708,15,15C481.999,475.267,475.27,481.995,467,481.995z"
        />

        <path
          d="M150.007,182.002c-33.083,0-59.999,26.915-59.999,59.999c0,33.083,26.915,59.999,59.999,59.999
			c33.083,0,59.999-26.915,59.999-59.999C210.006,208.918,183.09,182.002,150.007,182.002z M150.007,272
			c-16.542,0-29.999-13.458-29.999-29.999s13.458-29.999,29.999-29.999c16.542,0,29.999,13.458,29.999,29.999
			S166.549,272,150.007,272z"
        />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesPlaygroundComponent.displayName = 'IconAmenitiesPlayground';

const IconAmenitiesPlayground = React.memo(IconAmenitiesPlaygroundComponent);

export default IconAmenitiesPlayground;
